import { useState } from "react";
import bot from '../../assets/images/happy.png';
import you from '../../assets/images/boy.png';
import Catelog from './Catelog'
import Brands from './Brands'
import Recipes from './Recipes'
import ContactUs from "./ContactUs";
import Lastmenu from "./LastMenu";


function Mainmenu({name, mobile}) {
  const [activeFrames, setActiveFrames] = useState([{ id: 1, component: "MainMenu" }]); // Root frame

  const [time] = useState(new Date());

  const handleShowFrame = (parentId, frameName) => {
    setActiveFrames((prevFrames) => [
      ...prevFrames, 
      { id: prevFrames.length + 1, parentId, component: frameName },
    ]);
  };

  const renderFrame = (frame) => {
    let FrameComponent = null;
    switch (frame.component) {
      case "Catelog":
        FrameComponent = Catelog;
        break;
      case "Brands":
        FrameComponent = Brands;
        break;
      case "Refund Policy":
        return(
            <>
               <div className="you-time">
              <img src={you} alt="boy" className="boy" />
              You {time?.toLocaleTimeString()}
            </div>
            <div className='you-message'>
              <div className='frame2'>Refund Policy</div>
            </div>
              <Lastmenu />
            </>
          );
        case "Shipping Policy":
            return(
                <>
                   <div className="you-time">
                  <img src={you} alt="boy" className="boy" />
                  You {time?.toLocaleTimeString()}
                </div>
                <div className='you-message'>
                  <div className='frame2'>Shipping Policy</div>
                </div>
                  <Lastmenu />
                </>
              );
      case "Recipes":
        return(
            <>
               <div className="you-time">
              <img src={you} alt="boy" className="boy" />
              You {time?.toLocaleTimeString()}
            </div>
            <div className='you-message'>
              <div className='frame2'>Recipes</div>
            </div>
              <Lastmenu />
            </>
          );
        case "Contact Us":
        FrameComponent = ContactUs;
        break;
            
      default:
        return null;
    }

    return (
      <>
         <div className="you-time">
          <img src={you} alt="boy" className="boy" />
          You {time?.toLocaleTimeString()}
        </div>
        <div className="you-message">
          <div className="frame2">{frame.component}</div>
        </div>
        <FrameComponent key={frame.id} handleShowFrame={handleShowFrame} parentId={frame.id} />
      </>
    );
  };

  return (
    <>

      <div className='chatbot'>
        <img src={bot} alt="bot" className="bot" />
        <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
      </div>

      <div className="frame1 animated-frame">
        {/* <img src={image} className="IMAGE" alt="img" /> */}
        <div className="box1">
          Team Agromech is here to resolve all your queries
          Please choose an option below:
          <div style={{textAlign: 'center',marginTop: '10px'}}>
            <button className="detatils-button2" onClick={() => handleShowFrame(2, "Catelog")}>
              Catelog
            </button>
            <button className="detatils-button2" onClick={() => handleShowFrame(3, "Brands")}>
              Brands
            </button>
            <a href="https://agromech.com/policies/refund-policy" target="_blank" rel="noopener noreferrer">
            <button className="detatils-button2" onClick={() => handleShowFrame(4, "Refund Policy")}>
             Refund Policy
            </button>
            </a>
            <a href="https://agromech.com/policies/shipping-policy" target="_blank" rel="noopener noreferrer">
            <button className="detatils-button2" onClick={() => handleShowFrame(5, "Shipping Policy")}>
             Shipping Policy
            </button>
            </a>
            <a href="https://agromech.com/blogs/recipes" target="_blank" rel="noopener noreferrer">
            <button className="detatils-button2" onClick={() => handleShowFrame(6, "Recipes")}>
            Recipes
            </button>
            </a>
            <button className="detatils-button2" onClick={() => handleShowFrame(7, "Contact Us")}>
              Contact Us
            </button>
          </div>
        </div>
      </div>

      {/* Render all active frames in their proper order */}
      {activeFrames.slice(1).map(renderFrame)}
    </>
  );
}

export default Mainmenu;